import { useEffect, useState } from "react"
import { dictionaryCRUD } from "../../../actions/dictionary"
import { selector } from "../../../api"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from "react-toastify"
import Select from "react-select";


const dictionaryItemSchema = Yup.object().shape({
  dictionary_item_name_en: Yup.string().required('English name is required'),
  dictionary_item_name_sw: Yup.string().required('Swahili name is required'),
  dictionary: Yup.string().required('Dictionary is required'),
})

const initialValues = {
  dictionary_item_name_en: '',
  dictionary_item_name_sw: '',
  dictionary_item_parent: null,
  dictionary: '',
}

export const AddDictionaryItem = (props) => {

  const {setIndex, index} = props

  const user = selector.User()
  const [loading, setLoading] = useState(false)
  const [dictionary, setDictionary] = useState([])

  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadAllDictionary().then((resp) => {
        setDictionary(resp.data)
      }).finally(() => { })
    }, 2000)
  }, [])


  const formik = useFormik({
    initialValues,
    validationSchema: dictionaryItemSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { dictionary_item_name_en, dictionary_item_name_sw, dictionary_item_parent, dictionary } = values
      const recorded_by = user.id
      const data = { dictionary_item_name_en, dictionary_item_name_sw, dictionary_item_parent, dictionary, recorded_by }
      setLoading(true)
      setTimeout(() => {
        dictionaryCRUD.addDictionaryItem(data).then(() => {
          toast.success('New dictionary item has been created.', { autoClose: 7000 })
          setIndex(index+1)
          resetForm()
          setSubmitting(false)
          setLoading(false)
        }).catch((error) => {
          const errorMsg = error.response?.data ? JSON.stringify(error.response.data) : error.message
          toast.error(errorMsg, { autoClose: 7000 })
          setSubmitting(false)
          setLoading(false)
        })
      }, 2000)
    }
  })


  return (
    <>
      <div className="modal fade addModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="myLargeModalLabel">New Dictionary Item</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr/>
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label className="form-label">English Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" {...formik.getFieldProps('dictionary_item_name_en')} placeholder="English Name" />
                      {formik.touched.dictionary_item_name_en && formik.errors.dictionary_item_name_en && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.dictionary_item_name_en}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label className="form-label">Swahili Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" {...formik.getFieldProps('dictionary_item_name_sw')} placeholder="Swahili Name" />
                      {formik.touched.dictionary_item_name_sw && formik.errors.dictionary_item_name_sw && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.dictionary_item_name_sw}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="lastNameinput" className="form-label">Dictionary <span className="text-danger">*</span></label>
                      <Select
                        options={
                          dictionary?.map((dt) => (
                            {value : dt.id, label : dt.dictionary_name_en}
                          ))
                        }
                        placeholder="Select Dictionary"
                        onChange={(e) => formik.setFieldValue('dictionary', e.value)}
                        isSearchable={true}
                      />
                      {formik.touched.dictionary && formik.errors.dictionary && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.dictionary}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <hr/>
              <div className="modal-footer">
                <a href="javascript:void(0);" className="btn btn-soft-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
                <button type='submit' className="btn btn-soft-success" disabled={formik.isSubmitting || !formik.isValid}>
                  {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>save </span>}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )

}